import React from "react";
import IconBackground, { IconBackgroundSizes } from 'components/atoms/IconBackground'
import { colorList } from 'utils/colors'
import { ThemedShared, ThemedValues } from 'styles/themed'
import { StyleSheet, View } from 'react-native'
import _ from 'lodash'
import { IconBackgroundStyles } from 'styles/components/atoms/IconBackground'
import { LinearGradient } from 'expo-linear-gradient'
import { IconContainerStyles } from 'styles/components/atoms/IconContainer'


const IconContainer = ({ backgroundIcons = [], icon, linearGradientColours, size = 50 }) => {
	
	let iconView = null;
	switch( true ) {
		case _.isFunction( icon ):
			iconView = icon({ size: 24, color: colorList.ORANGE.primary })
			break;
			
		case _.isObject( icon ):
			iconView = icon;
			break;
	}
	
	if( !linearGradientColours || !_.isArray( linearGradientColours ) ) {
		linearGradientColours = [
			colorList.WHITE.primary,
			colorList.WHITE.dark
		]
	}
	
	return (
		<View
			style={ { width: size, height: size } }>
			
			{ backgroundIcons !== false ? (
				<IconBackground
					icons={ backgroundIcons }
					colourfull={ true }
					iconSize={ IconBackgroundSizes.S }
					linearGradientColours={ linearGradientColours }
					containerStyle={ staticStyles.iconBackgroundBorderRadiusBorderRadius}>
					
					<View style={ IconContainerStyles.iconContainer }>
						{ iconView }
					</View>
				</IconBackground>
			) : (
				<LinearGradient
					colors={ linearGradientColours }
					style={ [ IconBackgroundStyles.gradientOverlay, staticStyles.linearGradientOpacity1BorderRadiusBorderRadius]}>
					
					<View style={ IconContainerStyles.iconContainer }>
						{ iconView }
					</View>
				</LinearGradient>
			) }
		</View>
	)
}

const staticStyles = StyleSheet.create({
	iconBackgroundBorderRadiusBorderRadius: {
		borderRadius: ThemedShared.borderRadius.borderRadius,
	},
	linearGradientOpacity1BorderRadiusBorderRadius: {
		opacity: 1,
		borderRadius: ThemedValues.borderRadius,
	},
});

export default IconContainer
